import React from 'react';

import { APPS } from 'rebook/apps/base/components/apps/constants';

import styles from './style.scss';


const AppsStoreIcons = ({ target }) => {
  const query = target ? `?pagetype=${target}` : '';
  return (
    <div>
      <span className={styles.androidApp}>
        <a className={styles.linkApp}
          onClick={() => yaMetrikaReachGoal('PushButtonAndroid')}
          href={`${APPS.android.installUrl}${query}`}>
          android
        </a>
      </span>
      <span className={styles.iosApp}>
        <a className={styles.linkApp}
          onClick={() => yaMetrikaReachGoal('PushButtoniOS')}
          href={`${APPS.ios.installUrl}${query}`}>
          ios
        </a>
      </span>
    </div>
  );
};

export default AppsStoreIcons;
